import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=412d6e72&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=ts"
export * from "./NotificationsList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=412d6e72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d6e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('412d6e72')) {
      api.createRecord('412d6e72', component.options)
    } else {
      api.reload('412d6e72', component.options)
    }
    module.hot.accept("./NotificationsList.vue?vue&type=template&id=412d6e72&scoped=true", function () {
      api.rerender('412d6e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/NotificationsList.vue"
export default component.exports